
import { useStore } from "../../state/state.ts";
import Statistics from "../statistics.tsx";
export default function StatisticsFoerderprogramme() {
  const total_possible_subsidy_from = useStore((state)=>state.total_possible_subsidy_from);
  const total_possible_subsidy_to = useStore((state)=>state.total_possible_subsidy_to);
  
  if (!total_possible_subsidy_from){return <></>}

  return (
    <Statistics label={"Förderung"} now={Math.round(total_possible_subsidy_from)+' - '+Math.round(total_possible_subsidy_to)} future={undefined} unit={"€"} />
  )
}